import { MenuItem, ListItemIcon, Menu } from "@mui/material";
import React from "react";
export const FMenu = ({ anchorEl, open, handleClose, menuItems, anchorOrigin = { vertical: "bottom", horizontal: "right" }, transformOrigin = { vertical: "top", horizontal: "right" }, }) => {
    return (React.createElement(Menu, { anchorEl: anchorEl, id: "account-menu", open: open, onClose: handleClose, onClick: handleClose, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, slotProps: {
            paper: {
                sx: {
                    minWidth: 200,
                    borderRadius: "12px",
                    padding: "4px",
                    boxShadow: "-20px 20px 40px -4px rgba(145,158,171,0.24), 0px 0px 2px 0px rgba(145,158,171,0.24)",
                    mt: 0.5,
                },
            },
        } }, menuItems.map((item, index) => (React.createElement(MenuItem, { key: index, sx: Object.assign({ borderRadius: "6px", py: "6px", px: "8px", gap: "8px", fontSize: 14, color: item.color === "error" ? "error.main" : "inherit", "& svg": {
                color: item.color === "error" ? "error.main" : "inherit",
            } }, (item.sx || {})), onClick: item.onClick, disabled: item.disabled },
        item.icon && (React.createElement(ListItemIcon, { sx: { minWidth: "auto" } }, item.icon)),
        item.label)))));
};
